import {ContractRequest} from "../../../models";

export class ContractAdvancedSearchForm {

    contractNumber: string|null = null

    public toRequest() : ContractRequest {
        let request: ContractRequest = new ContractRequest()

        request.contractNumber = this.contractNumber

        return request
    }

}
